export const programas = [
    
    {
        "titulo" : "Apoyo al Autoempleo",
        "descripcion" : "Cuyo objetivo es, impulsar actividades productivas por cuenta propia, que permita a personas que enfrentan mayores barreras, insertarse al mercado laboral formal...",
        "trimestres" : [
            {
                "trimestre" : ".",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/AUTOEMPLEO.pdf"
            }
        ]
    },{
        "titulo" : "Especialización para la Empleabilidad (Empresas)",
        "descripcion" : "Cuyo objetivo es otorgar hasta dos apoyos económicos durante su proceso de especialización en empresas y/o sucursales debidamente...",
        "trimestres" : [
            {
                "trimestre" : ".",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/EMPLEABILIDAD_EMPRESAS.pdf"
            }
        ]
    },{
        "titulo" : "Especialización para la Empleabilidad (Buscadores de Empleo)",
        "descripcion" : "Cuyo objetivo es la vinculación a una empresa formal a fin de que la persona beneficiaria pueda fortalecer sus conocimientos, habilidades y/o competencias...",
        "trimestres" : [
            {
                "trimestre" : ".",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/BUSCADORES_EMPLEO.pdf"
            }
        ]
    },{
        "titulo" : "Impulso a la Movilidad Laboral",
        "descripcion" : "Cuyo objetivo es promover la movilidad laboral de los buscadores de empleo que requieran trasladarse a una entidad federativa distinta...",
        "trimestres" : [
            {
                "trimestre" : ".",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/IMPULSO_MOVILIDAD_LABORAL.pdf"
            }
        ]
    }
]